<!-- Loading overlay -->
@if (loading) {
  <div class="justify-content-center align-items-center bg-white-alpha-70 z-5 fixed left-0 top-0 flex h-full w-full">
    <div class="flex-column align-items-center flex">
      <p-skeleton
        shape="circle"
        size="4rem"
        styleClass="mb-2"
      ></p-skeleton>
      <p-skeleton
        width="10rem"
        height="2rem"
      ></p-skeleton>
    </div>
  </div>
}

<!-- Toast container for messages -->
<p-toast position="top-right"></p-toast>
<p-confirmDialog></p-confirmDialog>

<!-- Main Container -->
<div class="surface-ground detail-page p-2 sm:p-4">
  <!-- Page header component -->
  <app-booking-page-header
    [booking]="booking"
    [isSaving]="isSaving"
    [hasChanges]="changeTracker.hasUnsavedChanges"
    [canLinkChain]="!chain && !changeTracker.hasUnsavedChanges"
    (actionEvent)="onActionEvent($event)"
    (linkChain)="onChainLinkRequested()"
  ></app-booking-page-header>

  <!-- Quick info component -->
  <app-booking-quick-info [booking]="booking"></app-booking-quick-info>

  @if (chain) {
    <app-booking-chain-strip
      [chain]="chain"
      [blocked]="changeTracker.hasUnsavedChanges"
      (navigateRequested)="onChainNavigate($event)"
      (linkRequested)="onChainLinkRequested()"
      (detachRequested)="onChainDetach($event)"
    ></app-booking-chain-strip>
  }
  @if (chainForDialog) {
    <app-booking-chain-link-dialog
      [(visible)]="linkDialogVisible"
      [chain]="chainForDialog"
      (linked)="onChainLinked()"
    ></app-booking-chain-link-dialog>
  }

  <!-- Main tabs content -->
  <p-tabs
    [(value)]="activeTabIndex"
    styleClass="booking-tabs surface-card shadow-1 border-round overflow-hidden"
  >
    <p-tablist>
      <!-- General Tab -->
      <p-tab [value]="0">
        <div class="align-items-center flex">
          <span>{{ 'booking.detail.tabs.general' | translate }}</span>
          <span class="ml-2 inline-flex h-6 w-6 items-center justify-center">
            @if (tabChangeCount['general'] > 0) {
              <p-badge
                [value]="tabChangeCount['general']"
                severity="warn"
              ></p-badge>
            }
          </span>
        </div>
      </p-tab>

      <!-- Personal Data Tab -->
      <p-tab [value]="1">
        <div class="align-items-center flex">
          <span>{{ 'booking.detail.tabs.personal' | translate }}</span>
          <span class="ml-2 inline-flex h-6 w-6 items-center justify-center">
            @if (tabChangeCount['personal'] > 0) {
              <p-badge
                [value]="tabChangeCount['personal']"
                severity="warn"
              ></p-badge>
            }
          </span>
        </div>
      </p-tab>

      <!-- Rooms Tab -->
      <p-tab [value]="2">
        <div class="align-items-center flex">
          <span>{{ 'booking.detail.tabs.rooms' | translate }}</span>
          <span class="ml-2 inline-flex h-6 w-6 items-center justify-center">
            @if (tabChangeCount['rooms'] > 0) {
              <p-badge
                [value]="tabChangeCount['rooms']"
                severity="warn"
              ></p-badge>
            }
          </span>
        </div>
      </p-tab>

      <!-- Billing Tab -->
      <p-tab [value]="3">
        <div class="align-items-center flex">
          <span>{{ 'booking.detail.tabs.billing' | translate }}</span>
          <span class="ml-2 inline-flex h-6 w-6 items-center justify-center">
            @if (tabChangeCount['billing'] > 0) {
              <p-badge
                [value]="tabChangeCount['billing']"
                severity="warn"
              ></p-badge>
            }
          </span>
        </div>
      </p-tab>
    </p-tablist>

    <p-tabpanels>
      <p-tabpanel [value]="0">
        <app-booking-general-tab
          [booking]="booking"
          (actionEvent)="onActionEvent($event)"
        ></app-booking-general-tab>
      </p-tabpanel>

      <p-tabpanel [value]="1">
        <app-booking-personal-tab
          [booking]="booking"
          (actionEvent)="onActionEvent($event)"
        ></app-booking-personal-tab>
      </p-tabpanel>

      <p-tabpanel [value]="2">
        <app-booking-rooms-tab
          [booking]="booking"
          (actionEvent)="onActionEvent($event)"
        ></app-booking-rooms-tab>
      </p-tabpanel>

      <p-tabpanel [value]="3">
        <app-booking-billing-tab
          [booking]="booking"
          (actionEvent)="onActionEvent($event)"
        ></app-booking-billing-tab>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
